import useSalesChannels from './useSalesChannels';

export default useSalesChannels;
